export default __webpack_public_path__ + "static/media/ISSO SYLLABUS 2027-26 CLASS 3.6ac04ef3.pdf";